import type { TaskResponse } from '@erp/rpc';
import { canTransitionTaskStatus } from '@erp/shared-utils';

/**
 * Split a bulk selection into the ids that may move to `target` and a count
 * of the rest, so one task in the wrong status skips instead of sinking the
 * whole batch.
 */
export function partitionByTransition(
  tasks: Pick<TaskResponse, 'id' | 'status'>[],
  target: TaskResponse['status'],
): { ids: string[]; skipped: number } {
  const ids = tasks
    .filter((task) => canTransitionTaskStatus(task.status, target))
    .map((task) => task.id);
  return { ids, skipped: tasks.length - ids.length };
}
